import ImageBlock from '@intercom/embercom-composer/blocks/types/image';
import VideoFileBlock from '@intercom/embercom-composer/blocks/types/video-file';
import Attachment from '@intercom/embercom-composer/blocks/types/attachment';
import $ from 'jquery';
import { reads } from '@ember/object/computed';
import Em from 'ember';
export default Em.Mixin.create({
  appId: reads('app.id'),
  allowedTypes: Em.computed('uploadType', 'config.allowedImageTypes', 'config.allowedVideoTypes', 'config.allowedFileTypes', function () {
    switch (this.get('uploadType')) {
      case 'image':
        return this.get('config.allowedImageTypes');
      case 'video':
        return this.get('config.allowedVideoTypes');
    }
    return this.get('config.allowedFileTypes');
  }),
  allowedTypeList: Em.computed('allowedTypes', function () {
    return this.get('allowedTypes').join(',');
  }),
  blockClass: Em.computed('uploadType', function () {
    switch (this.get('uploadType')) {
      case 'image':
        return ImageBlock;
      case 'video':
        return VideoFileBlock;
    }
    return Attachment;
  }),
  openFileDialog() {
    let $fileInput = $('.composer-file-upload', this.element);
    $fileInput.val(null);
    $fileInput.trigger('click');
    this.set('frozenBlockInsertionIndex', this.get('hoverCoordinates.insertionIndex'));
  },
  isAcceptableFile(file) {
    let allowedTypes = this.get('allowedTypes');
    if (allowedTypes.includes('*')) {
      return true;
    }
    return allowedTypes.includes(file.type);
  },
  insertBlockOptions: Em.computed('frozenBlockInsertionIndex', function () {
    return {
      index: this.get('frozenBlockInsertionIndex'),
      selectNewBlock: false
    };
  }),
  insertMediaFile(file) {
    if (!this.isAcceptableFile(file)) {
      return;
    }
    let block = this.get('blockClass').create({
      config: this.get('config'),
      uploadManager: this.get('uploadManager'),
      file
    });
    this.send('insertBlock', block, this.get('insertBlockOptions'));
  }
});